// material-ui
import { TypographyVariantsOptions } from '@mui/material/styles';

// types
import { FontFamily } from 'types/config';

// project-imports
import { clacUiGlobal as ui } from 'utils/uiGlobal';

// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

export default function Typography(fontFamily: FontFamily): TypographyVariantsOptions {
  return {
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    // h1-h3 alineados a la escala del sistema de diseño (dd_pantallas/Shell General - CLAC DD (standalone).html — .content-header-title), con la familia heading
    h1: {
      fontFamily: ui.fonts.families.heading,
      fontWeight: 800,
      fontSize: ui.fonts.sizes['2xl'],
      lineHeight: 1.15,
      letterSpacing: '-0.01em'
    },
    h2: {
      fontFamily: ui.fonts.families.heading,
      fontWeight: 700,
      fontSize: ui.fonts.sizes.xl,
      lineHeight: 1.25
    },
    h3: {
      fontFamily: ui.fonts.families.heading,
      fontWeight: 600,
      fontSize: ui.fonts.sizes.lg,
      lineHeight: 1.3
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.5
    },
    h6: {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: 1.57
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.66
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.57
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: 1.66
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.57
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.66
    },
    overline: {
      lineHeight: 1.66
    },
    button: {
      textTransform: 'none'
    }
  };
}
